
export default function DefaultConfig(props) {
    window.location.href = "/mapping?df=1"
}